import { render, staticRenderFns } from "./MyAttachmentApprovalList.vue?vue&type=template&id=3577889d&lang=pug&"
import script from "./MyAttachmentApprovalList.vue?vue&type=script&lang=js&"
export * from "./MyAttachmentApprovalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports